import React from "react";
import { Helmet } from 'react-helmet';
import newimage from "../assets/newimage.png";
import Headingcomp from "../components/Headingcomp";
import Contactform from "../components/Contactform";
import AnimateInView from "../components/AnimateInView";
import Talk from "../components/Talk";

const Contact = () => {
  return (
    <main>
      <Helmet>
        <title>Contact Dhiman Wood Works | Custom Furniture Inquiries</title>
        <meta name="description" content="Get in touch for custom wooden furniture and woodworking services. Connect with our master craftsmen for your next project." />
      </Helmet>

      <Headingcomp
        heading="GET IN TOUCH"
        subheading="CRAFTING YOUR VISION IN WOOD"
        image={newimage}
      />

      <AnimateInView delay={0.2}>
        <Contactform />
      </AnimateInView>

      <AnimateInView delay={0.2}>
        <Talk />
      </AnimateInView>
    </main>
  );
};

export default Contact;
